module.exports = __webpack_public_path__ + "img/pdf.8025dd5b.png";